'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Button } from "./Button";
import { View } from "./View";
/**
 * Renders a customizable button that serves as an accordion toggle to
 * expand/hide content.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-47}
 */ export function ButtonAccordion(props) {
    var _props_defaultExpanded;
    var _useState = _sliced_to_array(useState((_props_defaultExpanded = props.defaultExpanded) !== null && _props_defaultExpanded !== void 0 ? _props_defaultExpanded : false), 2), expanded = _useState[0], setExpanded = _useState[1];
    var _props_buttonSize;
    return /*#__PURE__*/ _jsxs(View, {
        children: [
            /*#__PURE__*/ _jsx(Button, {
                _accentColor: props.color,
                testID: props.testID,
                variant: "text",
                size: (_props_buttonSize = props.buttonSize) !== null && _props_buttonSize !== void 0 ? _props_buttonSize : 'small',
                "aria-label": props.text,
                "aria-expanded": expanded,
                accessibilityActions: [
                    {
                        name: 'activate',
                        label: expanded ? 'collapse' : 'expand'
                    }
                ],
                onAccessibilityAction: function() {
                    setExpanded(function(e) {
                        return !e;
                    });
                },
                onPress: function() {
                    setExpanded(function(e) {
                        return !e;
                    });
                },
                text: props.text,
                iconRight: expanded ? 'caret-up' : 'caret-down',
                style: [
                    props.style,
                    expanded ? props.expandedStyle : null
                ]
            }),
            expanded ? props.children : null
        ]
    });
}
